import { ReactElement, Suspense } from 'react';

const Loader = ({ children }: { children: ReactElement }): ReactElement => (
  <Suspense fallback={null}>{children}</Suspense>
);

export default Loader;
